export function LinkedinIcon({ className }: { className?: string }) {
    return (
      <svg 
        className={className} 
        width="21" 
        height="22" 
        viewBox="0 0 21 22" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <path 
          d="M19.5 0.5H1.49531C0.670312 0.5 0 1.17969 0 2.01406V19.9859C0 20.8203 0.670312 21.5 1.49531 21.5H19.5C20.325 21.5 21 20.8203 21 19.9859V2.01406C21 1.17969 20.325 0.5 19.5 0.5ZM6.34687 18.5H3.23438V8.47812H6.35156V18.5H6.34687ZM4.79062 7.10938C3.79219 7.10938 2.98594 6.29844 2.98594 5.30469C2.98594 4.31094 3.79219 3.5 4.79062 3.5C5.78437 3.5 6.59531 4.31094 6.59531 5.30469C6.59531 6.30312 5.78906 7.10938 4.79062 7.10938ZM18.0141 18.5H14.9016V13.625C14.9016 12.4625 14.8781 10.9672 13.2844 10.9672C11.6625 10.9672 11.4141 12.2328 11.4141 13.5406V18.5H8.30156V8.47812H11.2875V9.84687H11.3297C11.7469 9.05937 12.7641 8.22969 14.2781 8.22969C17.4281 8.22969 18.0141 10.3062 18.0141 13.0062V18.5Z" 
          fill="#F2F2F2" 
        />
      </svg>
    )
  }